export default __webpack_public_path__ + "static/alpaca-logo-f7fcf612582ebf134e0d118b5d62670f.svg";